import React, { useContext, useEffect } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
/* eslint-disable */
import { AppRoute } from '../config/route-config';
import { UserProvider } from '../context/user/UserProvider';
import { PermissionsProvider } from '../context/permission/PermissionsProvider';
import { UserFetcher } from '../components/UserFetcher/UserFetcher';
// import { Placeholder2 } from '../components/PlaceHolder2/PlaceHolder2';
import { Drop } from '../racstrapComponent/dropComponent/drop';
import { Finaldrops } from '../racstrapComponent/finalDropComponent/finalDrop';
import { PastDropLog } from '../racstrapComponent/DropLogs/PastDroplog';
import { DrawerAudit } from '../racstrapComponent/drawerAudit/drawerAudit';
import { PaidIn } from '../racstrapComponent/CashPaid/PaidInComponent';
import { PaidOut } from '../racstrapComponent/CashPaid/PaidOutComponent';
import { DropReconciliation } from '../racstrapComponent/DropReconciliation/DropReconciliation';
import { DepositReceipt } from '../racstrapComponent/DropReconciliation/DepositReceipt';

import { DropReconciliationSummary } from '../racstrapComponent/DropReconciliation/DropReconciliationSummary';
import { DropReconciliationDetails } from '../racstrapComponent/DropReconciliation/DropReconciliationDetail';
import i18next from 'i18next';
import { CashmanagementProvider, CashmgmtContext, MakeFeatureFlagObjFn, } from '../context/CashManagementContext';
import { getConfigDetails, getStoreDetailsByNumber } from '../api/user';
export const routesTestId = 'routesTestId';

export const Routes = () => {
  const { language, setLanguage,FindCountry,setFindCountry,setFeatureFlagDetails} = useContext(CashmgmtContext)
  
  // eslint-disable-next-line no-console
  console.log('inside cash mgmt routes', useHistory());

  useEffect(() => {
    
    const language: any = window.sessionStorage.getItem('language')
    i18next.changeLanguage(language)
    console.log(language, "laaang")
    setLanguage(language)
    
    const getFeatureFlagDetails = async()=>{
    let featureFlagResponse : any
          featureFlagResponse = await getConfigDetails({storeNumbers: [sessionStorage.getItem('storeNumber')],paramKeyNames: ['MaxDrawerLimit' ,'ReconciliationMaxLimit','DrawerDefaultAmount','MinDropAmount','MXCashMgmtAccess','DateTimeLocalization'],})
          console.log(featureFlagResponse,'featureFlagResponse');
        if (featureFlagResponse?.storeProfileResponse?.configDetails[0].configDetails ) {
          const FeatureFlagObj = MakeFeatureFlagObjFn(
            featureFlagResponse.storeProfileResponse.configDetails[0].configDetails
          );
          setFeatureFlagDetails(FeatureFlagObj);
        }
    }

             

    async function fetchStoreData() {
      const storeNumber = window.sessionStorage.getItem('storeNumber');
      if (storeNumber) {
        try {
           const details = await getStoreDetailsByNumber(storeNumber);
          console.log(details, 'details api');
          if (details.status === 200 && details.data.response.length > 0) {
            const countryCode = details?.data.response[0]?.countryAbb;
            setFindCountry(countryCode);
            console.log("Fetched Country Code:", countryCode);
          }
          else {
            console.warn("API returned invalid or empty store details.");a
          }
        } catch (error) {
          console.error("Error fetching store details:", error);
        }
      }
    }
    const encodedData = sessionStorage.getItem('storeDetails');
    console.log(encodedData, 'encodedData in transform')
    let storeName = '';
    if (encodedData) {
      const decodedData = atob(encodedData);
      const storeDetails = JSON.parse(decodedData);
      console.log(storeDetails, 'storeDetails in transform')
      storeName = storeDetails?.storeName
      setFindCountry(storeDetails?.country || '')
    } else {
      fetchStoreData();
    }

  getFeatureFlagDetails();

    

  }, [])
  console.log(language, "context lang")

  return (
    <UserProvider>
      <PermissionsProvider>
        <UserFetcher />
        <div data-testid={routesTestId}>
          <Switch>
            <Route exact path={AppRoute.Index}>
              <Redirect to={AppRoute.Drops} />
            </Route>
            <Route exact path={AppRoute.Drops}>
              <Drop />
            </Route>
            <Route exact path={AppRoute.Finaldrops}>
              <Finaldrops />
            </Route>
            <Route exact path={AppRoute.paidIn}>
              <PaidIn />
            </Route>
            <Route exact path={AppRoute.paidOut}>
              <PaidOut />
            </Route>
            <Route exact path={AppRoute.PastDrop}>
              <PastDropLog />
            </Route>
            <Route exact path={AppRoute.CashDrop}>
              <PastDropLog />
            </Route>

            <Route exact path={AppRoute.CashDrop}>
              <PastDropLog />
            </Route>
            <Route exact path={AppRoute.DrawerAudit}>
              <DrawerAudit />
            </Route>
            <Route
              exact
              path="/cashmgmt/reconcil"
              component={DropReconciliation}
            />
            <Route
              exact
              path="/cashmgmt/reconcil/summary"
              component={DropReconciliationSummary}
            />
            <Route
              exact
              path="/cashmgmt/reconcil/detail"
              component={DropReconciliationDetails}
            />
            <Route
              exact
              path="/cashmgmt/reconcil/depositreceipt"
              component={DepositReceipt}
            />
            {/* <DrawerAudit /> */}
            {/* <Route exact path={AppRoute.Placeholder2}>
            <Placeholder2 />
          </Route> */}
          </Switch>
        </div>
      </PermissionsProvider>
    </UserProvider>
  );
};
